import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { MITPService } from "./mitp.service";
import { MedicalTool } from "../entities/tools/medical-tool";

interface MedicalToolPayload {
	label: string;
	html: string;
	css?: string;
	js?: string;
	tagIds: number[];
}

@Injectable({
	providedIn: "root",
})
export class MedicalToolService {
	private readonly http = inject(HttpClient);
	private readonly mitp = inject(MITPService);

	getAll(): Observable<MedicalTool[]> {
		return this.http.get<MedicalTool[]>(this.mitp.MedicalTools());
	}

	getOne(id: number): Observable<MedicalTool> {
		return this.http.get<MedicalTool>(`${this.mitp.MedicalTools()}/${id}`);
	}

	create(payload: MedicalToolPayload): Observable<MedicalTool> {
		return this.http.post<MedicalTool>(this.mitp.MedicalTools(), payload);
	}

	update(id: number, payload: MedicalToolPayload): Observable<MedicalTool> {
		return this.http.post<MedicalTool>(`${this.mitp.MedicalTools()}/${id}`, payload);
	}

	delete(id: number): Observable<void> {
		return this.http.delete<void>(`${this.mitp.MedicalTools()}/${id}`);
	}
}
